<template>
  <b-table :data="data" paginated pagination-size="is-small" per-page="10">
    <b-table-column
      v-for="(column, index) in columns"
      :key="index"
      :field="column.field"
      :label="column.label"
      v-slot="props"
    >
      <b-tooltip
        position="is-top"
        type="is-danger is-light"
        size="is-large"
        multilined
        :active="fieldHasError(props.row.row, column.field)"
        :class="[
          fieldHasError(props.row.row, column.field)
            ? 'has-background-danger-light'
            : '',
        ]"
        :dashed="fieldHasError(props.row.row, column.field)"
      >
        <template #content>
          <ul>
            <li
              v-for="(error, index) in fieldErrors(props.row.row, column.field)"
              :key="index"
            >
              {{ error }}
            </li>
          </ul>
        </template>
        {{
          props.row[column.field] ||
          (fieldHasError(props.row.row, column.field) ? 'NO INPUT' : '')
        }}
      </b-tooltip>
    </b-table-column>
  </b-table>
</template>

<script>
export default {
  props: {
    errors: { type: Object },
  },
  computed: {
    parsedErrors() {
      const parsed = JSON.parse(this.errors[0]);

      if (typeof parsed === 'object') {
        return Object.values(parsed);
      }

      return parsed;
    },
    data() {
      const tableRows = this.parsedErrors.reduce((acc, error) => {
        if (!acc[error.row]) {
          acc[error.row] = { row: error.row, values: error.values };
        }
        return acc;
      }, {});

      return Object.values(tableRows).map((error) => {
        return {
          row: error.row,
          ...error.values,
        };
      });
    },
    columns() {
      const fields = [
        {
          field: 'row',
          label: 'row',
          width: '40',
          numeric: true,
        },
      ];

      const additionalFields = Object.keys(this.parsedErrors[0].values).map(
        (fieldName) => {
          return {
            field: fieldName,
            label: fieldName,
          };
        }
      );

      fields.push(...additionalFields);

      return fields;
    },
  },
  methods: {
    rowErrors(row) {
      return this.parsedErrors.filter((error) => error.row === row);
    },
    fieldHasError(row, attribute) {
      return this.rowErrors(row).some((error) => error.attribute === attribute);
    },
    fieldErrors(row, attribute) {
      const errors = this.rowErrors(row).filter(
        (error) => error.attribute === attribute
      )[0]?.errors;
      return errors;
    },
  },
};
</script>

<style scoped>
.b-table::v-deep .icon {
  width: 0.75rem;
}
</style>
